
import PresentationModel from './PresentationModel';
import './PresentationMetadataService';

export default ['PresentationMetadata', (PresentationMetadataService) => {
    return PresentationModel.get(PresentationMetadataService);
}];